export default __webpack_public_path__ + "static/media/indexBg.7406c328.jpg";